var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXroomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 326,
    viewBox: "0 0 333 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5735 0.00431718L-0.0117188 36.6611L105.995 140.122L143.58 103.465L37.5735 0.00431718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.41 -0.100801L188.422 103.378L226.013 140.028L332.002 36.5496L294.41 -0.100801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.986 183.904L188.4 220.561L294.407 324.022L331.993 287.365L225.986 183.904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.037 183.813L0.0111084 287.256L37.5897 323.919L143.615 220.476L106.037 183.813Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 333,
    height: 326,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXroomIcon);
export default __webpack_public_path__ + "static/media/xroom_icon.58057dc09d5ccedd8d1378d0dc67029f.svg";
export { ForwardRef as ReactComponent };